import React from 'react';
import './Advice.css'
import { Button } from 'react-bootstrap';
import { MdEventSeat, MdPhoneAndroid, MdTab } from 'react-icons/md';

const Advice = ({callback}) => {
    return (
        <div className="adviceContainer">
            <div className="advisory">
                <div className="advisoryCell">
                    <div className="advisoryPic advisoryPicIcon">
                        <MdPhoneAndroid size={36} color="rgba(255, 255, 255, 0.9)" />
                    </div>
                    <div className="advisoryText">Put your phone on silent or away</div>
                </div>
                <div className="advisoryCell">
                    <div className="advisoryPic advisoryPicIcon">
                        <MdTab size={36} color="rgba(255, 255, 255, 0.9)" />
                    </div>
                    <div className="advisoryText">Close unnecessary tabs and apps</div>
                </div>
                <div className="advisoryCell">
                    <div className="advisoryPic advisoryPicIcon">
                        <MdEventSeat size={36} color="rgba(255, 255, 255, 0.9)" />
                    </div>
                    <div className="advisoryText">Ensure a comfortable, quiet environment</div>
                </div>
            </div>
            
            <div className='advisoryAction'>
                <Button 
                    variant="primary" 
                    size="lg" 
                    onClick={() => {
                        if (callback) {
                            callback();
                            if (window.adviceTimer != null) {
                                window.clearTimeout(window.adviceTimer)
                                window.adviceTimer = undefined
                            }
                        }
                    }}
                >
                    Let's Go
                </Button>
            </div>
        </div>
    );
}

export default React.memo(Advice);